let instMessgMapper = [
    {
        key: 'verify_resize',
        value: 'resize action'
    },
    {
        key: 'resize',
        value: 'resize action'
    },
    {
        key: 'rescuing',
        value: 'rescue action'
    },
    {
        key: 'unrescuing',
        value: 'unrescue action'
    },
    {
        key: 'image_snapshot',
        value: 'snapshot creation'
    },
    {
        key: 'image_pending_upload',
        value: 'snapshot creation'
    },
    {
        key: 'image_uploading',
        value: 'snapshot creation'
    },
    {
        key: 'image_snapshot_pending',
        value: 'snapshot creation'
    },
    {
        key: 'build',
        value: 'creation'
    },
    {
        key: 'rebuild',
        value: 'rebuild action'
    },
    {
        key: 'start',
        value: 'start action'
    },
    {
        key: 'reboot',
        value: 'reboot action'
    },
    {
        key: 'powering-off',
        value: 'power off action'
    },
    {
        key: 'powering-on',
        value: 'start action'
    },
    {
        key: 'deleting',
        value: 'delete action'
    },
    {
        key: 'shutoff',
        value: 'start action'
    },
    {
        key: 'suspended',
        value: 'unshelve action'
    },
    {
        key: 'shelving',
        value: 'shelve action'
    },
    {
        key: 'shelved',
        valu: 'shelve action'
    },
];

export const getInstMessage = (messg) => {
    if(messg === undefined || messg === null) {
        return messg;
    }
    if(String(messg).startsWith('shelving')) {
        messg = "shelving";
    }
    let ob = instMessgMapper.find(item => String(messg).toLowerCase() === String(item.key).toLowerCase());
    if(ob !== undefined) {
        return "Instance " + ob.value + " is in progress ...";
    }
    return "Instance " + String(messg).toLowerCase() + " action is in progress ...";
};
export default instMessgMapper;